import React from 'react';
import { supabase } from '../lib/supabase';
import { useTranslation } from 'react-i18next';

interface GoogleSignInButtonProps {
  mode: 'signin' | 'signup';
  className?: string;
}

export function GoogleSignInButton({ mode, className = '' }: GoogleSignInButtonProps) {
  const { t } = useTranslation();
  
  const handleGoogleSignIn = async () => {
    try {
      // Get the current origin (works for both localhost and production)
      const redirectTo = `${window.location.origin}/create-profile`;
      
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: redirectTo,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          },
        },
      });

      if (error) throw error;
    } catch (err) {
      console.error('Error signing in with Google:', err);
    }
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      className={`w-full h-12 flex items-center justify-center space-x-3 border border-gray-custom/20 rounded-lg text-light hover:bg-gray-custom/5 transition-colors ${className}`}
    >
      <svg width="20" height="20" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27c3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10c5.35 0 9.25-3.67 9.25-9.09c0-1.15-.15-1.81-.15-1.81Z"
        />
      </svg>
      <span>{mode === 'signin' ? t('auth.login.googleSignIn') : t('auth.register.googleSignUp')}</span>
    </button>
  );
}